export default __webpack_public_path__ + "static/media/kuchnia13.484dfb3a.jpg";